var _mask, _g, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _rect3, _path7, _rect4, _line, _line2, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictedAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 154,
    viewBox: "0 0 171 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_362",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 167,
    height: 154
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.642 131.12L19.8937 153.274L1.14131 22.1536L148.89 -8.07863e-05L167.642 131.12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2803 23.003C87.3022 10.3983 115.374 -6.41854 141.235 24.8113C167.096 56.0411 163.507 102.039 133.166 127.586C102.825 153.132 69.5294 137.976 36.0174 115.409C-9.7263 84.6393 7.15945 34.2469 45.2803 23.003Z",
    fill: "#D4ECFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0195 20.8687L44.3748 12.5113C44.672 11.4567 45.7624 10.8376 46.8204 11.1228L96.121 24.4133",
    stroke: "#5392BD",
    strokeWidth: 0.947545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5632 110.72L20.2205 109.629C19.1363 109.356 18.4861 108.248 18.7771 107.168L32.0528 57.9227",
    stroke: "#5392BD",
    strokeWidth: 0.947545
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.879 41.317L168.236 43.6723C169.291 43.9695 169.91 45.0599 169.624 46.1179L156.334 95.4185",
    stroke: "#5392BD",
    strokeWidth: 0.947545
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8179,
    y: 25.4462,
    width: 130.086,
    height: 102.329,
    rx: 4,
    fill: "#00194D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8179,
    y: 23.9393,
    width: 130.086,
    height: 102.329,
    rx: 2,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6309 100.887C77.3778 90.2758 103.793 83.9093 114.516 100.887",
    stroke: "#00194D",
    strokeWidth: 1.26339
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9214 26.0964C27.9214 24.9918 28.8168 24.0964 29.9214 24.0964H155.8C156.905 24.0964 157.8 24.9918 157.8 26.0964V31.3965H27.9214V26.0964Z",
    fill: "#0075C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.397 134.22L144.04 142.674C143.744 143.734 142.647 144.356 141.585 144.065L87.3436 129.218",
    stroke: "#5392BD",
    strokeWidth: 0.947545
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2916,
    y: 24.4131,
    width: 129.139,
    height: 101.381,
    rx: 1.52623,
    stroke: "#00194D",
    strokeWidth: 0.947545
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.768 39.0566L151.907 40.1586M151.54 37.2199C151.54 38.64 150.388 39.7913 148.968 39.7913C147.548 39.7913 146.397 38.64 146.397 37.2199C146.397 35.7998 147.548 34.6486 148.968 34.6486C150.388 34.6486 151.54 35.7998 151.54 37.2199Z",
    stroke: "#00194D",
    strokeWidth: 0.947545,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2946,
    y: 34.3559,
    width: 101.133,
    height: 6.09534,
    rx: 0.526228,
    fill: "#ACD2ED",
    stroke: "#00194D",
    strokeWidth: 0.947545
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.8179,
    y1: 30.9226,
    x2: 157.904,
    y2: 30.9226,
    stroke: "#00194D",
    strokeWidth: 0.947545
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27.8179,
    y1: 44.1798,
    x2: 157.904,
    y2: 44.1798,
    stroke: "#00194D",
    strokeWidth: 0.947545
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.079 62.9127L102.822 76.3119M116.079 76.3119L102.822 62.9127",
    stroke: "#00194D",
    strokeWidth: 1.26339,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.486 62.9126L69.6431 76.3118M82.486 76.3118L69.6431 62.9126",
    stroke: "#00194D",
    strokeWidth: 1.26339,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccess);
export default __webpack_public_path__ + "static/media/restrictedAccess.327adcc0c676718fb3cb32a7611aa235.svg";
export { ForwardRef as ReactComponent };